module.exports = __webpack_public_path__ + "static/inheritor-d0f33b86fe8e1c9079be477e5e1c652b.png";